import React, { useEffect, useState } from "react";
import BannerGrid from "../components/BannerGrid";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";
import CategorySection from "../components/CategorySection";
import * as api from "../services/api";
import { useCart } from "../contexts/CartContext";

import style from "../../src/style.css";

export default function Home(){
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [serviceable, setServiceable] = useState(null); // null=unknown, true/false known
  const [locationMsg, setLocationMsg] = useState("");
  const { addToCart } = useCart();

  useEffect(()=>{
    loadProducts();
  },[]);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const productsData = await api.getProducts();
      setProducts(productsData.slice(0, 12)); // Show first 12 products on home
    } catch (error) {
      console.error('Error loading products:', error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // On first load, ask for location and check serviceability
  useEffect(() => {
    const checked = sessionStorage.getItem("service_checked");
    if (checked) {
      setServiceable(sessionStorage.getItem("serviceable") === "true");
      setLocationMsg(sessionStorage.getItem("service_msg") || "");
      return;
    }

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          // TODO: replace with API request:
          // const res = await fetch('/api/check-serviceability', {method:'POST', body: JSON.stringify({lat:latitude, lng:longitude})})
          // const data = await res.json();
          // setServiceable(data.serviceable); setLocationMsg(data.message);
          // Simulate: serviceable if lat is >0 (just demo)
          const demoServiceable = true;
          setServiceable(demoServiceable);
          setLocationMsg("Serviceable at your location");
          sessionStorage.setItem("service_checked", "1");
          sessionStorage.setItem("serviceable", demoServiceable ? "true" : "false");
          sessionStorage.setItem("service_msg", "Serviceable at your location");
        },
        (err) => {
          console.warn("Location denied or failed", err);
          setServiceable(false);
          setLocationMsg("Location permission denied. Please enter mobile or postal to check.");
          sessionStorage.setItem("service_checked", "1");
          sessionStorage.setItem("serviceable", "false");
          sessionStorage.setItem("service_msg", locationMsg);
        },
        { timeout: 8000 }
      );
    } else {
      setServiceable(false);
      setLocationMsg("Geolocation unavailable. Please enter mobile or postal to check.");
      sessionStorage.setItem("service_checked", "1");
      sessionStorage.setItem("serviceable", "false");
      sessionStorage.setItem("service_msg", locationMsg);
    }
  },[]);

  return (
    <div className="container">
      
      {/* <section className="service-check">
        <div className={`service-pill ${serviceable ? "ok" : "bad"}`}>
          {serviceable === null ? "Checking serviceability..." : locationMsg}
        </div>
        {serviceable === false && (
          <div className="service-actions">
            <input placeholder="Enter mobile or postal code" className="input-small" />
            <button className="btn">Check</button>
          </div>
        )}
      </section> */}
      <BannerGrid />
      <CategorySection />

      <section className="product-section">
        <h2>Popular items</h2>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>Loading products...</div>
        ) : (
          <div className="product-grid">
            {products.length > 0 ? (
              products.map(p => (
                <ProductCard 
                  key={p._id} 
                  product={p} 
                  disabled={serviceable===false}
                  onAddToCart={addToCart}
                />
              ))
            ) : (
              <p style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2rem' }}>
                No products available at the moment.
              </p>
            )}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}
